import { render, staticRenderFns } from "./nature1_1.vue?vue&type=template&id=0dfe5466&scoped=true&"
import script from "./nature1_1.vue?vue&type=script&lang=js&"
export * from "./nature1_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfe5466",
  null
  
)

export default component.exports